import { useState } from "react";

interface PropsColor {
    onChangColor: any;
}

export function InputColor(props: PropsColor) {

    const [color, setColor] = useState<string>("#000000");

    const handleChangeColor = (event: any) => {
        let value = event.target.value;
        setColor(value);
        props.onChangColor(value)
    };

    return (
        <div className="d-flex input-class-qr items-center gap-10 mb-3 mb-3">
            <input type="text" className="flex-1 border-trans back-trans width-100-100" placeholder="#000000" value={color} onChange={handleChangeColor} />
            <input type="color" className="w-10 h-10 p-0 border-trans rounded" title="Pick a color" value={color} onChange={handleChangeColor} />
        </div>
    )

}